import Image from '@base/FutureImage';
import {
  getChapterCount,
  getMonthIcon,
  renderCount
} from '@cont/Compete/utils';
import styled from '@emotion/styled';
import { Fonts, mediaQuery, Spacings } from '@styles/index';
import RightChevron from 'aquilla/icons/actions/RightChevron';

const MonthWrapper = styled.div`
  width: 272px;
  padding: ${Spacings.SPACING_4B};
  border: 1px solid var(--color-divider);
  border-radius: 8px;
  display: flex;
  position: relative;
  justify-content: space-between;
  align-items: center;
  cursor: pointer;
  &:hover {
    ${({ $isDisabled }) =>
      $isDisabled
        ? 'cursor: not-allowed;'
        : 'background: var(--color-base-light-0)'}
  }
  ${mediaQuery.uptoMobile} {
    width: 100%;
    height: 80px;
  }
`;

const Arrow = styled.div`
  display: flex;
  opacity: 0;
  transition: 0.3s ease;
  margin-right: -16px;
  ${MonthWrapper}:hover & {
    opacity: 1;
    transform: translateX(-16px);
  }
`;

const MonthText = styled.div`
  font-weight: ${Fonts.SEMIBOLD};
  font-size: ${Fonts.H5};
  line-height: 24px;
  margin-bottom: ${Spacings.SPACING_2};
  color: var(--color-text-primary);
`;

const ChapterCount = styled.div`
  font-weight: ${Fonts.REGULAR};
  font-size: ${Fonts.P1};
  line-height: 20px;
  color: var(--color-text-secondary);
`;

const Tag = styled.div`
  width: 45px;
  height: 20px;
  font-weight: ${Fonts.BOLD};
  font-size: ${Fonts.P2};
  line-height: 12px;
  border-radius: 4px;
  background-color: var(--color-i-blue-27);
  display: flex;
  position: absolute;
  right: ${Spacings.SPACING_4B};
  align-items: center;
  justify-content: center;
  color: var(--color-i-blue);
  transition: 0.3s ease;
  ${MonthWrapper}:hover & {
    transform: ${({ $isDisabled }) =>
      $isDisabled ? 'none' : 'translateX(-30px)'};
  }
`;

const Flex = styled.div`
  display: flex;
`;

const MonthWithChapter = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: ${Spacings.SPACING_4B};
`;

const Month = ({
  syllabus,
  handleMonthClick,
  className,
  currentMonth,
  pastMonth
}) => {
  const { month, subjects, soon } = syllabus;
  return (
    <MonthWrapper
      onClick={handleMonthClick}
      $isDisabled={getChapterCount(subjects) === 0}
      className={className}
    >
      <Flex>
        <Image
          src={getMonthIcon(soon, currentMonth, pastMonth)}
          alt="month"
          width={48}
          height={48}
        />
        <MonthWithChapter>
          <MonthText>{month}</MonthText>
          <ChapterCount>{renderCount(subjects)}</ChapterCount>
        </MonthWithChapter>
      </Flex>
      {soon && <Tag $isDisabled={getChapterCount(subjects) === 0}>SOON</Tag>}
      {getChapterCount(subjects) > 0 && (
        <Arrow>
          <RightChevron />
        </Arrow>
      )}
    </MonthWrapper>
  );
};

export default Month;
